import { FC, useState } from 'react';
import { Grid, TextField, Button, Autocomplete, CircularProgress, Box } from '@mui/material';
import { AvaSuburbs } from '@models';
import { fillPostcodeAndName } from '../helpers/postcodes';
import { useGetSuburbsListQuery } from '@services';
import { AvaStoreRanking } from './AvaStoreRanking';
import { LoadingButton } from '@mui/lab';

const AvaSuburbPriorities: FC = () => {
  const [searchSuburbKey, setSearchSuburbKey] = useState('');
  const [searchSuburb, setSearchSuburb] = useState('');
  const { data, isLoading } = useGetSuburbsListQuery();
  const getSuburbCode = (data && fillPostcodeAndName(data)) || [];
  const [loading, setLoading] = useState(false);

  const handleLoadingChange = (isLoading: boolean) => {
    setLoading(isLoading);
  };

  if (isLoading)
    return (
      <Box sx={{ height: '100vh' }} display="flex" alignItems="center" justifyContent="center" data-testid="ava-loader">
        <CircularProgress color="inherit" size={75} />
      </Box>
    );

  return (
    <>
      <Grid container alignItems="center" spacing={2} p={2}>
        <Grid item xs={10}>
          <Autocomplete
            id="suburb-search"
            data-testid="get-suburb-searchbar"
            onChange={(e: any, newValue: AvaSuburbs | null) => {
              setSearchSuburbKey(newValue?.key ?? '');
            }}
            options={getSuburbCode}
            getOptionLabel={(option) => option?.suburb_postcode ?? ''}
            disablePortal
            renderInput={(params) => <TextField {...params} label="Search by suburb name or postcode" />}
          />
        </Grid>
        <Grid item>
          <LoadingButton
            loading={loading}
            variant="contained"
            onClick={() => setSearchSuburb(searchSuburbKey)}
            data-testid="get-suburb-button"
          >
            Search
          </LoadingButton>
        </Grid>
      </Grid>
      {searchSuburb !== '' && <AvaStoreRanking searchSuburb={searchSuburb} setLoading={handleLoadingChange} />}
    </>
  );
};

export default AvaSuburbPriorities;
